package com.example.mystybag.sharedmodels.project.responseModels.merchant

import com.example.mystybag.sharedmodels.base.BaseResponseModel
import kotlinx.serialization.Serializable

@Serializable
data class GenerateMerchantVerificationCodeResponseModel(
    val email: String = ""
) : BaseResponseModel()

